import React from "react";

const Footer = () => {
  return (
    <footer className="bg-gray-900 py-4">
      <div className="container mx-auto px-4 text-center text-sm text-white">
        &copy; {new Date().getFullYear()} Laxmi Civil Engineering Services Pvt. Ltd. All Rights Reserved.
      </div>
    </footer>
  );
};

export default Footer;
